<script setup>
import GuestLayout from '@/layouts/GuestLayout.vue'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import { computed, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import countries from '@/countries'


const countriesList = countries
const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const { getLoginError } = storeToRefs(authStore)
const codeReadonly = ref(false)
const route = useRoute()

const form = ref({
  username: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  country: '',
  city: '',
  address: '',
  password: '',
  code: '',
})
onMounted(() => {
  const urlCode = route.query?.code
  if (urlCode) {
    form.value.code = urlCode
    codeReadonly.value = true
  }
})
const submit = async () => {
  await authStore.register(form.value)
}
</script>

<template>
  <GuestLayout>
    <div class="w-full max-w-96 mx-auto pt-12">
      <div class="w-full bg-[var(--color-grey9)] p-5">
        <form @submit.prevent="submit">
          <div class="space-y-2.5 mb-5">

            <input
              type="text"
              class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
              :placeholder="$t('register.username')"
              v-model="form.username"
            />

            <div class="flex space-x-2.5">
              <input
                type="text"
                class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
                :placeholder="$t('register.firstName')"
                v-model="form.first_name"
              />
              <input
                type="text"
                class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
                :placeholder="$t('register.lastName')"
                v-model="form.last_name"
              />
            </div>

            <input
              type="text"
              class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
              :placeholder="$t('register.email')"
              v-model="form.email"
            />

            <input
              type="text"
              class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
              :placeholder="$t('register.phone')"
              v-model="form.phone"
            />

            <div class="flex space-x-2.5">
                <select
                    class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0 bg-white text-gray-600"
                    v-model="form.country"
                >
                    <option value="" disabled selected>{{ $t('register.country') }}</option>
                    <option 
                        v-for="c in countries" 
                        :key="c.id" 
                        :value="c.name"
                        class="text-gray-600"
                    >
                        {{ c.name }}
                    </option>
                </select>

                <input
                    type="text"
                    class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
                    :placeholder="$t('register.city')"
                    v-model="form.city"
                />
            </div>

            <input
              type="text"
              class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
              :placeholder="$t('register.address')"
              v-model="form.address"
            />

            <input
              type="password"
              class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
              :placeholder="$t('register.password')"
              v-model="form.password"
            />

            <input
              type="text"
              class="w-full h-12 px-2.5 text-[15px] border-gray-400 focus:border-gray-500 focus:ring-0"
              :class="{ 'bg-gray-400/20 text-gray-400 cursor-not-allowed': codeReadonly }"
              :placeholder="$t('register.code')"
              v-model="form.code"
            :readonly="codeReadonly"
            />

          </div>

          <div 
            class="bg-red-200/50 text-red-600 border border-red-700 py-2 px-3 mb-5"
            v-if="getLoginError"
          >
            <p class="text-[15px]">{{ t(getLoginError) }}</p>
          </div>

          <!-- <button
            class="bg-[var(--color-primary1)] h-12 w-full flex items-center justify-center text-white text-[15px] font-bold"
            type="submit"
          >
            {{ $t('register.register') }}
          </button> -->
        </form>
        <div class="text-center mt-4 text-[14px] text-gray-900">
            {{ $t('register.haveAccount') }}
            <span 
                class="text-[var(--color-primary1)] font-semibold cursor-pointer ml-1"
                @click="router.push('/login')"
            >
                {{ $t('register.login') }}
            </span>
        </div>
      </div>
    </div> 
  </GuestLayout>
</template>
